import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import seedrandom from "seedrandom"
import $ from "jquery";

const rng = seedrandom('laviecestunetresgrosseboitedechocolat');

export class AnimationSceneAtom {

  constructor({selector, x, y, type, visibility}) {
    this.initialX = x;
    this.initialY = y;
    this.initialVisibility = visibility;
    this.type = type;

    this.wiggleTl = null

    this.$el = $(selector);
    this.init();
  }

  init() {

    // Initial position
    this.reset()

    // Wiggle wrapper
    this.setWiggle(1)
  }

  animateOut() {
    gsap.killTweensOf(this.$el, "autoAlpha")
    gsap.to(this.$el, {
      autoAlpha: 0,
    });

    gsap.killTweensOf(this.$el.find(".molecule"));
    gsap.to(this.$el.find(".molecule"), {
      scale: 0.5,
    });
  }

  animateIn(delay) {
    gsap.killTweensOf(this.$el, "autoAlpha")
    gsap.to(this.$el, {
      autoAlpha: 1,
      delay: delay,
    });

    gsap.killTweensOf(this.$el.find(".molecule"));
    gsap.to(this.$el.find(".molecule"), {
      scale: 1,
      ease: "back.out",
      delay: delay,
    });
  }

  setWiggle(intensity) {

    if (this.wiggleTl) {
      this.wiggleTl.kill();
      this.wiggleTl = null;
    }

    this.wiggleTl = gsap.timeline({})
    gsap.killTweensOf(this.$el.find(".wiggle-wrapper"))
    if(intensity ===0 ) return;

    const basicConfig = {
      yoyo: true,
      repeat: -1,
      overwrite: "auto",
      ease: "sine.inOut"
    };

    let durationModifier = 1;
    if (intensity > 1) durationModifier = 0.3

    this.wiggleTl.to(this.$el.find(".wiggle-wrapper"), {
      y: (rng() + 1) * 10 * intensity * (rng() > 0.5 ? -1 : 1),
      duration: (rng() + 1) * 2 * durationModifier,
      ...basicConfig
    }, 0);

    this.wiggleTl.to(this.$el.find(".wiggle-wrapper"), {
      x: (rng() + 1) * 10 * intensity * (rng() > 0.5 ? -1 : 1),
      duration: (rng() + 1) * 2 * durationModifier,
      ...basicConfig
    }, 0);
  }


  reset() {

    if (this.wiggleTl) {
      this.wiggleTl.kill();
      this.wiggleTl = null;
    }

    gsap.set(this.$el, {
      x: this.initialX,
      y: this.initialY,
      autoAlpha: (this.initialVisibility) ? 1 : 0,
    });

    gsap.set(this.$el.find(".molecule"), {
      scale: (this.initialVisibility) ? 1 : 0.5,
    });

    //   this.$el.find(".option").removeClass("active");
    //   this.$el.find(".confirm-button").addClass("disabled");
    //   return this;
  }
}

